// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"da8cbd37","54":"8663bda0","218":"b4248009","399":"6158c9e0","646":"3b52485f","674":"ad8ead05"}[chunkId] + ".chunk.js";
};